<template>
  <div class="company-detail faq">
    <div class="page-title">
      <div>
        <router-link
          :to="{
            name: 'company',
          }"
          class="breadcrumb"
        >
          Company
        </router-link>
        <h2>FAQ</h2>
      </div>
      <div class="navigation" v-if="pages.length > 0">
        <a
          class="previous"
          :class="{ disabled: activeIndex === 0 }"
          @click.prevent="previous"
        >
          <SvgIcon name="chevron-left" />
        </a>
        <a
          class="next"
          :class="{ disabled: activeIndex === pages.length - 1 }"
          @click.prevent="next"
        >
          <SvgIcon name="chevron-right" />
        </a>
      </div>
    </div>
    <div class="company-detail__tabs">
      <CompanyTabs />
      <div
        class="content"
        v-touch:swipe.right="previous"
        v-touch:swipe.left="next"
      >
        <TransitionGroup name="fade">
          <div
            class="faq-cards"
            v-show="activeIndex === index"
            v-for="(page, index) in pages"
            :key="index"
            v-touch:swipe.right="next"
            v-touch:swipe.left="previous"
          >
            <div class="card" v-for="item in page" :key="item">
              <h2 v-html="escape(item.question)" />
              <p v-html="escape(item.answer)" />
            </div>
          </div>
        </TransitionGroup>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyTabs from '@/components/CompanyTabs';
import faq from '@/assets/data/faq';

export default {
  name: 'CompanyFAQView',
  components: {
    CompanyTabs,
  },
  data() {
    return {
      pages: this.chunk(faq, 3),
      activeIndex: 0,
    };
  },
  methods: {
    next() {
      let index = this.activeIndex + 1;

      if (this.pages[index]) {
        this.activeIndex = index;
      }
    },
    previous() {
      let index = this.activeIndex - 1;

      if (this.pages[index]) {
        this.activeIndex = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  .faq-cards {
    display: flex;
    gap: 3%;
    flex-direction: column;
    pointer-events: none;
    height: 100%;
    width: 100%;
    .card {
      background: $bg;
      padding: 3%;
      h2 {
        font-size: 125%;
        margin-bottom: 0.5%;
      }
      p {
        font-size: 80%;
        line-height: 1.4;
        margin: 0;
        color: $body;
      }
    }
  }
}
</style>
